.themeHeaderRoot {
  width: 100%;
  border-bottom: 1px solid var(--border-default);
  box-shadow: var(--elevation-strong);
}

.innerContainer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  max-width: 1280px;
  padding: 20px 20px 0;

  [data-tab-header] {
    border-bottom: none;
  }
}
